module.exports = __webpack_public_path__ + "static/02-2d9154e1b7026ada4902d847272cb4de.jpeg";